import React, { useState } from "react";
import Snippet from "components/MDX/Snippet";
import SnippetSpan from "components/SnippetSpan";
import HTTPMethod from "components/HTTPMethod";
import Select from "components/Form/fields/Select";
import LoadingSpinner from "components/LoadingSpinner";
import CopyToClipboard from "components/CopyToClipboard";
import { ToastProvider } from "react-toast-notifications";
import { LANGUAGE_LABEL_MAP, NO_INDENT_LANGUAGES } from "constants/docs";

const ADJUST_LOADER_POSITION = {
  marginTop: -4,
  marginBottom: -4
};

const RequestPreview = ({ title, snippets, details, loading } = {}) => {
  const languages = snippets ? Object.keys(snippets) : [];
  const [language, setLanguage] = useState(languages[0]);

  let code = snippets ? snippets[language] : "";
  if (NO_INDENT_LANGUAGES.indexOf(language) === -1) {
    code = JSON.stringify(code, null, 2);
  }
  const multipleLanguages = languages.length > 1;
  let actions;
  if (multipleLanguages) {
    actions = (
      <Select
        value={language}
        options={languages.map((language) => ({
          uid: language,
          label: LANGUAGE_LABEL_MAP[language]
        }))}
        onChange={() => (evt) => {
          const selection = evt.currentTarget.value;
          setLanguage(selection);
        }}
        labelTransform={(val) => val}
        customClasses={{
          container: "flex flex-shrink-0 pr1",
          input:
            "border-box input-reset ba b--black-20 pa2 mb0 db w-100 pv2 f5 br2 pr3"
        }}
      />
    );
  }

  return (
    <div className="request--preview w-100 bg-white ba hairline-1 br3 overflow-hidden shadow-0">
      <div className="flex flex-row justify-between items-center pa2 ma1">
        <div className="flex flex-row justify-between items-center w-100">
          <div className="flex flex-row w-100">
            {details && details.title && (
              <div className="fw5 f7 ttu">{details.title}</div>
            )}
            {details && details.method && (
              <HTTPMethod method={details.method} />
            )}
            {details && details.endpoint && (
              <div className="pl1">
                <SnippetSpan copy={details.endpoint} />
              </div>
            )}
          </div>
          {actions}
          {loading ? (
            <div style={ADJUST_LOADER_POSITION}>
              <LoadingSpinner customClasses={{ ring: "blue", size: "small" }} />
            </div>
          ) : (
            <ToastProvider placement="bottom-left">
              <CopyToClipboard
                customClasses={{
                  button:
                    "pa0 ma0 items-center flex dib items-center justify-center bn br1 panel--action relative bg-white",
                  default: "bg-white",
                  active: "color-primary"
                }}
                size={13}
                tooltip="Copy snippet"
                toast="Copied snippet"
                value={code}
              />
            </ToastProvider>
          )}
        </div>
      </div>
      <div className="bt w-100 hairline-1 flex flex-column">
        <Snippet
          hideCopyAction
          customClasses={{
            pre: "code__pre--preview ma0"
          }}
          code={code}
          language={language}
          withLines
        />
      </div>
    </div>
  );
};

export default RequestPreview;
